import React, { useCallback } from 'react';

interface FileUploadProps {
  onAudioUpload: (file: File) => void;
  onJsonUpload: (file: File) => void;
  audioFile: File | null;
  jsonFile: File | null;
}

const FileUpload: React.FC<FileUploadProps> = ({
  onAudioUpload,
  onJsonUpload,
  audioFile,
  jsonFile
}) => {
  const handleAudioDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && (file.type.startsWith('audio/') || file.name.match(/\.(mp3|wav|ogg|m4a|aac|flac)$/i))) {
      onAudioUpload(file);
    } else {
      alert('يرجى رفع ملف صوتي صحيح (MP3, WAV, OGG, M4A, AAC, FLAC)');
    }
  }, [onAudioUpload]);

  const handleJsonDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type === 'application/json') {
      onJsonUpload(file);
    }
  }, [onJsonUpload]);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.currentTarget.classList.add('dragover');
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.currentTarget.classList.remove('dragover');
  };

  const handleAudioFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && (file.type.startsWith('audio/') || file.name.match(/\.(mp3|wav|ogg|m4a|aac|flac)$/i))) {
      onAudioUpload(file);
    } else if (file) {
      alert('يرجى رفع ملف صوتي صحيح (MP3, WAV, OGG, M4A, AAC, FLAC)');
      e.target.value = '';
    }
  };

  const handleJsonFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onJsonUpload(file);
    }
  };

  return (
    <div>
      <div
        className="upload-section"
        onDrop={handleAudioDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <h3>رفع ملف صوتي</h3>
        <input
          type="file"
          accept="audio/*"
          onChange={handleAudioFileChange}
          className="file-input"
        />
        <p>اسحب وأفلت ملف صوتي هنا أو انقر للاختيار</p>
        {audioFile && (
          <p>مـختار: {audioFile.name}</p>
        )}
      </div>

      <div
        className="upload-section"
        onDrop={handleJsonDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <h3>رفع ملف مقاطع JSON</h3>
        <input
          type="file"
          accept=".json"
          onChange={handleJsonFileChange}
          className="file-input"
        />
        <p>اسحب وأفلت ملف JSON هنا أو انقر للاختيار</p>
        {jsonFile && (
          <p>مـختار: {jsonFile.name}</p>
        )}
      </div>
    </div>
  );
};

export default FileUpload;